import dayjs from "dayjs";
import "dayjs/locale/it";

dayjs.locale("it");

export const ROLES = {
  admin: { label: "Admin MSE", cls: "bg-purple-50 border-purple-200 text-purple-700" },
  coordinatore: { label: "Coordinatore d'Area", cls: "bg-amber-50 border-amber-200 text-amber-700" },
  shift_leader: { label: "Shift Leader", cls: "bg-blue-50 border-blue-200 text-blue-700" },
  operatore: { label: "Operatore Fiduciario", cls: "bg-emerald-50 border-emerald-200 text-emerald-700" },
  referente_hotel: { label: "Referente Hotel", cls: "bg-sky-50 border-sky-200 text-sky-700" },
};

export const ALL_ROLES = Object.keys(ROLES);
export const OPS = ["admin", "coordinatore", "shift_leader", "operatore"];
export const LEAD = ["admin", "coordinatore", "shift_leader"];
export const MGMT = ["admin", "coordinatore"];
export const isGlobal = (user) => MGMT.includes(user?.role);

export const PRIORITIES = {
  P1: { label: "P1 · Critica", sla: 5, cls: "bg-red-50 border-red-200 text-red-700", dot: "bg-red-500" },
  P2: { label: "P2 · Alta", sla: 15, cls: "bg-orange-50 border-orange-200 text-orange-700", dot: "bg-orange-500" },
  P3: { label: "P3 · Ordinaria", sla: 60, cls: "bg-amber-50 border-amber-200 text-amber-700", dot: "bg-amber-400" },
  P4: { label: "P4 · Pianificabile", sla: 1440, cls: "bg-slate-100 border-slate-200 text-slate-600", dot: "bg-slate-400" },
};

export const STATUS_CLS = {
  ok: "bg-emerald-50 border-emerald-200 text-emerald-700",
  warn: "bg-amber-50 border-amber-200 text-amber-700",
  bad: "bg-red-50 border-red-200 text-red-700",
  info: "bg-sky-50 border-sky-200 text-sky-700",
  neutral: "bg-slate-100 border-slate-200 text-slate-600",
};

export const TICKET_STATUS = { aperto: "Aperto", in_carico: "In carico", risolto: "Risolto", chiuso: "Chiuso" };

export const fmtDT = (v) => (v ? dayjs(v).format("DD/MM/YY HH:mm") : "—");
export const fmtD = (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "—");
export const today = () => dayjs().format("YYYY-MM-DD");
export { dayjs };
